//  _ __ ___ (_)___  ___
// | '_ ` _ \| / __|/ __|
// | | | | | | \__ \ (__
// |_| |_| |_|_|___/\___|

import { _FIND_INVOICE_PAYMENT_TRIGGER } from './misc';

export const FIND_INVOICE_PAYMENT_TRIGGER = _FIND_INVOICE_PAYMENT_TRIGGER;

// 		_           _     _                         _
//   __| | __ _ ___| |__ | |__   ___   __ _ _ __ __| |
//  / _` |/ _` / __| '_ \| '_ \ / _ \ / _` | '__/ _` |
// | (_| | (_| \__ \ | | | |_) | (_) | (_| | | | (_| |
//  \__,_|\__,_|___/_| |_|_.__/ \___/ \__,_|_|  \__,_|

import { _AGING_BALANCE, _AGING_BALANCE_RECIPIENT } from './dashboard';

export const AGING_BALANCE = _AGING_BALANCE;
export const AGING_BALANCE_RECIPIENT = _AGING_BALANCE_RECIPIENT;

//  _                 _
// (_)_ ____   _____ (_) ___ ___  ___
// | | '_ \ \ / / _ \| |/ __/ _ \/ __|
// | | | | \ V / (_) | | (_|  __/\__ \
// |_|_| |_|\_/ \___/|_|\___\___||___/

import { _GET_INVOICE, _GET_INVOICE_DATA, _GET_INVOICES, _GET_INVOICES_FOR_RECIPIENT, _FIND_INVOICES, _ACTIONS_BY_INVOICE } from './invoices';

export const GET_INVOICE = _GET_INVOICE;
export const GET_INVOICES = _GET_INVOICES;
export const GET_INVOICES_FOR_RECIPIENT = _GET_INVOICES_FOR_RECIPIENT;
export const FIND_INVOICES = _FIND_INVOICES;
export const ACTIONS_BY_INVOICE = _ACTIONS_BY_INVOICE;
export const GET_INVOICE_DATA = _GET_INVOICE_DATA;

//              _
//  _ __   ___ | |_ ___  ___
// | '_ \ / _ \| __/ _ \/ __|
// | | | | (_) | ||  __/\__ \
// |_| |_|\___/ \__\___||___/

import { _GET_NOTES, _GET_INVOICE_NOTES, _INSERT_NOTE, _INSERT_INVOICE_NOTE, _UPDATE_NOTE, _DELETE_NOTE, _DELETE_NOTE_INVOICE } from './notes';

export const GET_NOTES = _GET_NOTES;
export const GET_INVOICE_NOTES = _GET_INVOICE_NOTES;
export const INSERT_NOTE = _INSERT_NOTE;
export const INSERT_INVOICE_NOTE = _INSERT_INVOICE_NOTE;
export const UPDATE_NOTE = _UPDATE_NOTE;
export const DELETE_NOTE = _DELETE_NOTE;
export const DELETE_NOTE_INVOICE = _DELETE_NOTE_INVOICE;

//             _   _
//   __ _  ___| |_(_) ___  _ __  ___
//  / _` |/ __| __| |/ _ \| '_ \/ __|
// | (_| | (__| |_| | (_) | | | \__ \
//  \__,_|\___|\__|_|\___/|_| |_|___/

import { _GET_PARTICIPANT_ACTION_AGGREGATE, _GET_ACTIONS, _GET_INVOICE_ACTIONS, _GET_ACTION, _UPDATE_ACTION_ASSIGNEE, _INSERT_ACTION, _INSERT_MANUAL_ACTION_INVOICE_COPY, _GET_SEND_INVOICE_COPY_DATA, _UPDATE_ACTION_METADATA, _GET_NEXT_ACTIONS, _GET_NEXT_ACTIONS_V2, _ACTION_DETAILS_FIELDS_FRAGMENT } from './actions';

export const GET_PARTICIPANT_ACTION_AGGREGATE = _GET_PARTICIPANT_ACTION_AGGREGATE;
export const GET_ACTIONS = _GET_ACTIONS;
export const GET_INVOICE_ACTIONS = _GET_INVOICE_ACTIONS;
export const INSERT_ACTION = _INSERT_ACTION;
export const INSERT_MANUAL_ACTION_INVOICE_COPY = _INSERT_MANUAL_ACTION_INVOICE_COPY;
export const ACTION_DETAILS_FIELDS_FRAGMENT = _ACTION_DETAILS_FIELDS_FRAGMENT;
export const GET_SEND_INVOICE_COPY_DATA = _GET_SEND_INVOICE_COPY_DATA;
export const GET_ACTION = _GET_ACTION;
export const UPDATE_ACTION_ASSIGNEE = _UPDATE_ACTION_ASSIGNEE;
export const UPDATE_ACTION_METADATA = _UPDATE_ACTION_METADATA;
export const GET_NEXT_ACTIONS = _GET_NEXT_ACTIONS;
export const GET_NEXT_ACTIONS_V2 = _GET_NEXT_ACTIONS_V2;

// 		       _   _                    ___                 _
//   __ _  ___| |_(_) ___  _ __  ___   ( _ )    _ __   ___ | |_ ___  ___
//  / _` |/ __| __| |/ _ \| '_ \/ __|  / _ \/\ | '_ \ / _ \| __/ _ \/ __|
// | (_| | (__| |_| | (_) | | | \__ \ | (_>  < | | | | (_) | ||  __/\__ \
//  \__,_|\___|\__|_|\___/|_| |_|___/  \___/\/ |_| |_|\___/ \__\___||___/

//                                       _              _   _
//   __ _ _ __ ___  _   _ _ __   ___  __| |   __ _  ___| |_(_) ___  _ __  ___
//  / _` | '__/ _ \| | | | '_ \ / _ \/ _` |  / _` |/ __| __| |/ _ \| '_ \/ __|
// | (_| | | | (_) | |_| | |_) |  __/ (_| | | (_| | (__| |_| | (_) | | | \__ \
//  \__, |_|  \___/ \__,_| .__/ \___|\__,_|  \__,_|\___|\__|_|\___/|_| |_|___/
//  |___/                |_|

import { _GET_ALL_WORKLIST_ITEMS, _GET_ASSIGNED_WORKLIST_ITEMS, _GET_UNASSIGNED_WORKLIST_ITEMS } from './actions_grouped';

export const GET_ALL_WORKLIST_ITEMS = _GET_ALL_WORKLIST_ITEMS;
export const GET_ASSIGNED_WORKLIST_ITEMS = _GET_ASSIGNED_WORKLIST_ITEMS;
export const GET_UNASSIGNED_WORKLIST_ITEMS = _GET_UNASSIGNED_WORKLIST_ITEMS;

//                   _   _      _                   _
//  _ __   __ _ _ __| |_(_) ___(_)_ __   __ _ _ __ | |_ ___
// | '_ \ / _` | '__| __| |/ __| | '_ \ / _` | '_ \| __/ __|
// | |_) | (_| | |  | |_| | (__| | |_) | (_| | | | | |_\__ \
// | .__/ \__,_|_|   \__|_|\___|_| .__/ \__,_|_| |_|\__|___/
// |_|                           |_|

import { _GET_PARTICIPANTS, _GET_PARTICIPANT, _GET_PARTICIPANT_DETAILS, _GET_PARTICIPANTS_BY_USER } from './participants';

export const GET_PARTICIPANTS = _GET_PARTICIPANTS;
export const GET_PARTICIPANT = _GET_PARTICIPANT;
export const GET_PARTICIPANT_DETAILS = _GET_PARTICIPANT_DETAILS;
export const GET_PARTICIPANTS_BY_USER = _GET_PARTICIPANTS_BY_USER;

//  _                  _              _   _ _   _
// | | ___  __ _  __ _| |   ___ _ __ | |_(_) |_(_) ___  ___
// | |/ _ \/ _` |/ _` | |  / _ \ '_ \| __| | __| |/ _ \/ __|
// | |  __/ (_| | (_| | | |  __/ | | | |_| | |_| |  __/\__ \
// |_|\___|\__, |\__,_|_|  \___|_| |_|\__|_|\__|_|\___||___/
//         |___/

import { _GET_LEGAL_ENTITIES } from './legal_entities';

export const GET_LEGAL_ENTITIES = _GET_LEGAL_ENTITIES;

//                _       _            _
//  _ __ ___  ___(_)_ __ (_) ___ _ __ | |_ ___
// | '__/ _ \/ __| | '_ \| |/ _ \ '_ \| __/ __|
// | | |  __/ (__| | |_) | |  __/ | | | |_\__ \
// |_|  \___|\___|_| .__/|_|\___|_| |_|\__|___/
// 			   |_|

import { _GET_RECIPIENTS, _GET_RECIPIENT } from './recipients';

export const GET_RECIPIENTS = _GET_RECIPIENTS;
export const GET_RECIPIENT = _GET_RECIPIENT;

// 		   			  _ _ _      ___         _      _     _ _                 _
//   ___ _ __ ___  __| (_) |_   ( _ )     __| | ___| |__ (_) |_   _ __   ___ | |_ ___  ___
//  / __| '__/ _ \/ _` | | __|  / _ \/\  / _` |/ _ \ '_ \| | __| | '_ \ / _ \| __/ _ \/ __|
// | (__| | |  __/ (_| | | |_  | (_>  < | (_| |  __/ |_) | | |_  | | | | (_) | ||  __/\__ \
//  \___|_|  \___|\__,_|_|\__|  \___/\/  \__,_|\___|_.__/|_|\__| |_| |_|\___/ \__\___||___/

import { _CREDIT_NOTES, _DEBIT_NOTES } from './_credit_debit_notes';

export const GET_CREDIT_NOTES = _CREDIT_NOTES;
export const GET_DEBIT_NOTES = _DEBIT_NOTES;

//                                         _         _                                       _
//  _ __   __ _ _   _ _ __ ___   ___ _ __ | |_    __| | ___   ___ _   _ _ __ ___   ___ _ __ | |_ ___
// | '_ \ / _` | | | | '_ ` _ \ / _ \ '_ \| __|  / _` |/ _ \ / __| | | | '_ ` _ \ / _ \ '_ \| __/ __|
// | |_) | (_| | |_| | | | | | |  __/ | | | |_  | (_| | (_) | (__| |_| | | | | | |  __/ | | | |_\__ \
// | .__/ \__,_|\__, |_| |_| |_|\___|_| |_|\__|  \__,_|\___/ \___|\__,_|_| |_| |_|\___|_| |_|\__|___/
// |_|          |___/

import { _PAYMENT_DOCUMENT } from './payment';

export const PAYMENT_DOCUMENT = _PAYMENT_DOCUMENT;

//  					   _
//  _ __   ___  ___  _ __ | | ___
// | '_ \ / _ \/ _ \| '_ \| |/ _ \
// | |_) |  __/ (_) | |_) | |  __/
// | .__/ \___|\___/| .__/|_|\___|
// |_|              |_|

import { _GET_PARTICIPANT_USERS, _GET_PERSON_BY_EXTERNAL_ID, _GET_PARTICIPANT_BY_PERSON } from './people';

export const GET_PARTICIPANT_USERS = _GET_PARTICIPANT_USERS;
export const GET_PERSON_BY_EXTERNAL_ID = _GET_PERSON_BY_EXTERNAL_ID;
export const GET_PARTICIPANT_BY_PERSON = _GET_PARTICIPANT_BY_PERSON;

//                  _             _
//   ___ ___  _ __ | |_ __ _  ___| |_ ___
//  / __/ _ \| '_ \| __/ _` |/ __| __/ __|
// | (_| (_) | | | | || (_| | (__| |_\__ \
//  \___\___/|_| |_|\__\__,_|\___|\__|___/

import { _GET_CONTACTS, _GET_CONTACT } from './contacts';

export const GET_CONTACTS = _GET_CONTACTS;
export const GET_CONTACT = _GET_CONTACT;

//  _                       _       _
// | |_ ___ _ __ ___  _ __ | | __ _| |_ ___  ___
// | __/ _ \ '_ ` _ \| '_ \| |/ _` | __/ _ \/ __|
// | ||  __/ | | | | | |_) | | (_| | ||  __/\__ \
//  \__\___|_| |_| |_| .__/|_|\__,_|\__\___||___/
//                   |_|

import { _GET_TEMPLATES, _GET_TEMPLATE, _UPDATE_COMMUNICATION_TEMPLATE } from './templates';

export const GET_TEMPLATES = _GET_TEMPLATES;
export const GET_TEMPLATE = _GET_TEMPLATE;
export const UPDATE_COMMUNICATION_TEMPLATE = _UPDATE_COMMUNICATION_TEMPLATE;

//                _
//   ___ ___   __| | __ _
//  / __/ _ \ / _` |/ _` |
// | (_| (_) | (_| | (_| |
//  \___\___/ \__,_|\__,_|
//

import { _GET_STATEMENT_LINES } from './coda';

export const GET_STATEMENT_LINES = _GET_STATEMENT_LINES;

//                 _             _       _
//   ___ _ __   __| |_ __   ___ (_)_ __ | |_ ___
//  / _ \ '_ \ / _` | '_ \ / _ \| | '_ \| __/ __|
// |  __/ | | | (_| | |_) | (_) | | | | | |_\__ \
//  \___|_| |_|\__,_| .__/ \___/|_|_| |_|\__|___/
// 			        |_|

import { _DEACTIVATE_ENDPOINT, _REACTIVATE_ENDPOINT } from './_endpoints';

export const DEACTIVATE_ENDPOINT = _DEACTIVATE_ENDPOINT;
export const REACTIVATE_ENDPOINT = _REACTIVATE_ENDPOINT;

// LOOSE
import gql from 'graphql-tag';

export const INSERT_ACTION_INVOICE = gql`
	mutation insertActionInvoice($action: uuid!, $invoice: uuid!, $legal_entity: uuid!, $participant: uuid!, $relation: String!) {
		insert_risolto_action_invoice(objects: { relation: $relation, action: $action, invoice: $invoice, legal_entity: $legal_entity, participant: $participant }) {
			returning {
				reference
			}
			affected_rows
		}
	}
`;
